import { createContext } from 'react';

export type FormSubmitContextValue = () => Promise<void>;

export const FormSubmitContext = createContext<FormSubmitContextValue | null>(null);
